import HorizontalProgress from '@cp/src/components/ProgressBars/horizontalProgress/HorizontalProgress';
import { DateFormat, dateFormat, getFormatDate } from '@cp/src/utils/DateHelper';
import cx from 'classnames';
import styles from './index.module.scss';
import {
  AGENT_PERFORMANCE_FILTERS,
  IAgentAvailabilityHistoryParams,
  IAgentPerformanceParams
} from '../../constants/types';
import { convertTimeToMinutes } from '@cp/src/pages/DashboardV2/ActivityTracker/utils';
import { EXPECTED_ACTIVE_MINUTES } from '../../constants';
import AllCommonCell from './AllCommonCell';
import { rowClass } from './utils';

const commonCell = (
  urlParams: IAgentPerformanceParams,
  params: IAgentAvailabilityHistoryParams
) => {
  const {
    totalMinutes,
    activeMinutes,
    loginTimeStamp,
    logoutTimStamp,
    firstCallTimeStamp,
    breakDurationInMinutes,
    loginStatus,
    logoutStatus
  } = params || {};

  const isLateLogin = loginStatus === AGENT_PERFORMANCE_FILTERS.LATE_LOGGED_IN;
  const isLogoutEarly = logoutStatus === AGENT_PERFORMANCE_FILTERS.EARLY_LOGGED_OUT;

  const loginDate = loginTimeStamp ? getFormatDate(loginTimeStamp, DateFormat.hh_mm_ss_ampm) : '-';
  const logoutDate = logoutTimStamp ? getFormatDate(logoutTimStamp, DateFormat.hh_mm_ss_ampm) : '-';
  const firstCallDate = firstCallTimeStamp
    ? getFormatDate(firstCallTimeStamp, DateFormat.hh_mm_ss_ampm)
    : '-';
  const breakHoursFormat = convertTimeToMinutes(breakDurationInMinutes);

  const percentage = totalMinutes === 0 ? 0 : (activeMinutes / totalMinutes) * 100;
  const correctedPercentage = Math.min(percentage, 100);

  const computeClassNames =
    correctedPercentage > 75 || activeMinutes >= EXPECTED_ACTIVE_MINUTES
      ? styles.above75Percent
      : correctedPercentage > 55
      ? styles.above55Percent
      : styles.above25Percent;

  switch (urlParams?.radioOption) {
    case 'All':
      return (
        <AllCommonCell
          isLateLogin={isLateLogin}
          isLogoutEarly={isLogoutEarly}
          loginDate={loginDate}
          logoutDate={logoutDate}
          firstCallDate={firstCallDate}
          breakHoursFormat={breakHoursFormat}
          totalMinutes={totalMinutes}
          activeMinutes={activeMinutes}
          computeClassNames={computeClassNames}
          percentage={percentage}
        />
      );
    case 'LoginTime':
      return <div className={rowClass(isLateLogin)}>{loginDate}</div>;
    case 'LogoutTime':
      return <div className={rowClass(isLogoutEarly)}>{logoutDate || '-'}</div>;
    case 'FirstCall':
      return <div className={rowClass()}>{firstCallDate || '-'}</div>;
    case 'BreakHrs':
      return <div className={rowClass()}>{breakHoursFormat || '-'}</div>;
    case 'ActiveHrs':
    default:
      return !totalMinutes || !activeMinutes ? (
        <div className={styles.progressBarContainer}>
          <HorizontalProgress
            percentage={0}
            className={styles.zeroPercentage}
            percentageClassName={styles.progressColor}
          />
          <div className={styles.timeInHoursAndMinutes}>0 hr 0 min</div>
        </div>
      ) : (
        <div className={styles.progressBarContainer}>
          <HorizontalProgress
            percentage={correctedPercentage}
            className={computeClassNames}
            percentageClassName={styles.progressColor}
          />
          <div className={styles.timeInHoursAndMinutes}>{convertTimeToMinutes(activeMinutes)}</div>
        </div>
      );
  }
};
export default commonCell;
